import React, { FC, useMemo } from 'react';
import Prompt from '@ui/Prompt';
import { I18n, Translate } from 'react-redux-i18n';

import styles from './styles.module.scss';
import { StudentRatingProps } from './interfaces';

const StudentRating: FC<StudentRatingProps> = ({ rating }) => {
  const level = useMemo(() => {
    if (rating >= 1 && rating < 13) {
      return I18n.t('userLevels.beginner');
    } else if (rating >= 13 && rating < 25) {
      return I18n.t('userLevels.junior');
    } else if (rating >= 25 && rating < 40) {
      return I18n.t('userLevels.middle');
    } else if (rating >= 40) {
      return I18n.t('userLevels.senior');
    }
  }, [rating]);

  if (!rating || rating < 1) {
    return <></>;
  }

  return (
    <div className={styles.root}>
      <div className={styles.starSection}>
        <img
          className={styles.img}
          src={require(`../../../assets/images/icons/medal.png`)}
          alt="medal"
        />
        <span className={styles.starCount}>{rating}</span>
        <Prompt
          className={styles.prompt}
          style={{
            color: 'rgb(255 193 156)',
          }}
        >
          <span>
            <Translate dangerousHTML value="greeting.studentLevelPrompt" />
          </span>
        </Prompt>
      </div>

      <div className={styles.textSection}>
        <span className={styles.title}>{level}</span>
      </div>
    </div>
  );
};

export default StudentRating;
